export const SET_PORTAL_API = 'SET_PORTAL_API';
export const RESET_PORTAL = 'RESET_PORTAL';
export const SET_PORTAL_SLIDESHOW = 'SET_PORTAL_SLIDESHOW';
export const SET_PORTAL_FIRM = 'SET_PORTAL_FIRM';
export const SET_PORTAL_CONFIRM = 'SET_PORTAL_CONFIRM';
export const SET_PORTAL_BUTTONS = 'SET_PORTAL_BUTTONS';
export const SET_PORTAL_EDIT_ORDER = 'SET_PORTAL_EDIT_ORDER';
export const INCREMENT_SLIDE = 'INCREMENT_SLIDE';
export const DECREMENT_SLIDE = 'DECREMENT_SLIDE';
